import bookingEndpoints from 'actions/booking-endpoints';
import { authorizedFetch } from 'actions/fetch-helper';

// eslint-disable-next-line no-useless-escape
const latlngRegex = new RegExp(/^(\-?\d+(\.\d+)?),\s*(\-?\d+(\.\d+)?)$/);
const {
  getAddressSearchEpt,
  getAddressTranslationEpt,
  paxFetchSearchAddressEpt,
  getPaxAddressTranslationEpt,
} = bookingEndpoints;

export const validateLatlng = latlng => latlngRegex.test(latlng);

export const fetchAddressSearch = ({
  keyword,
  latlng,
  companyID,
  countryCode,
  isToggle,
  isPax,
}) =>
  // if pax login via gfb account then call getAddressSearchEpt
  // else pax login via grabid then call paxFetchSearchAddressEpt
  isPax
    ? authorizedFetch(
        paxFetchSearchAddressEpt({
          keyword,
          latlng,
          countryCode,
          isToggle,
        }),
        null,
        true,
      )
    : authorizedFetch(
        getAddressSearchEpt({
          keyword,
          latlng,
          companyID,
          countryCode,
          isToggle,
        }),
        companyID,
        true,
      );

export const fetchLatlngReverse = ({ lat, lng, companyID, isPax }) => {
  let url;
  if (isPax) {
    url = getPaxAddressTranslationEpt({ lat, lng });
    return authorizedFetch(url, null, true);
  }

  url = getAddressTranslationEpt({ lat, lng, companyID });
  return authorizedFetch(url, companyID, true);
};

export const getCityRefCoordinates = (
  selectedCity,
  useRefCoordinates = false,
) => {
  if (!selectedCity) {
    return undefined;
  }

  const { coordinates, refCoordinates } = selectedCity;

  if (useRefCoordinates && refCoordinates) {
    return refCoordinates;
  }

  return coordinates;
};
